import { render, staticRenderFns } from "./BoxButton.vue?vue&type=template&id=1e932772&scoped=true"
import script from "./BoxButton.vue?vue&type=script&lang=ts"
export * from "./BoxButton.vue?vue&type=script&lang=ts"
import style0 from "./BoxButton.vue?vue&type=style&index=0&id=1e932772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e932772",
  null
  
)

export default component.exports